import arrowsPosition from './arrowsPosition';
import arrowsVerticalPosition from './arrowsVerticalPosition';
import cubeType from './cubeType';
import dimensions from './dimensions';
import events from './events';
import deviceType from './deviceType';
import gallerySizeType from './gallerySizeType';
import galleryTextAlign from './galleryTextAlign';
import gridStyle from './gridStyle';
import cubeFitPosition from './cubeFitPosition';
import groupTypes from './groupTypes';
import imageHoverAnimations from './imageHoverAnimations';
import infoBehaviourOnHover from './infoBehaviourOnHover';
import infoType from './infoType';
import isVertical from './isVertical';
import itemClick from './itemClick';
import layout, { isLayout } from './layout';
import layoutDirection from './layoutDirection';
import loadingMode from './loadingMode';
import loadingWithColorMode from './loadingWithColorMode';
import loadMoreAmount from './loadMoreAmount';
import mobileSwipeAnimations from './mobileSwipeAnimations';
import overlayAnimations from './overlayAnimations';
import placements, { hasExternalAbovePlacement, hasExternalBelowPlacement, hasHoverPlacement, hasExternalRightPlacement, hasExternalLeftPlacement, hasExternalVerticalPlacement, hasExternalHorizontalPlacement, isExternalAbovePlacement, isExternalBelowPlacement, isHoverPlacement, isExternalRightPlacement, isExternalLeftPlacement, isExternalVerticalPlacement, isExternalHorizontalPlacement, isConstantVerticalPlacement, } from './placements';
import resizeMethods from './resizeMethods';
import scrollAnimations from './scrollAnimations';
import slideAnimations from './slideAnimations';
import scrollDirection from './scrollDirection';
import socialNetworks from './socialNetworks';
import textBoxWidthCalculationOptions from './textBoxWidthCalculationOptions';
import thumbnailsAlignment from './thumbnailsAlignment';
import thumbnailsPosition from './thumbnailsPosition';
import { URL_SIZES as urlSizes, URL_TYPES as urlTypes } from './urlTypes';
import videoPlay from './videoPlay';
import viewMode from './viewMode';
import imagePlacementAnimations from './imagePlacementAnimations';
import slideTransition from './slideTransition';
import overlayPositions from './overlayPositions';
import overlaySizeType from './overlaySizeType';
import autoSlideshowTypes from './autoSlideshowTypes';
import arrowsType from './arrowsType';
import arrowsContainerStyleType from './arrowsContainerStyleType';
import itemResolutionMode from './itemResolutionMode';
import autoSlideBehaviour from './autoSlideBehaviour';
import secondaryMediaTrigger from './secondaryMediaTrigger';
import secondaryMediaBehaviour from './secondaryMediaBehaviour';
// NEW STYPEPARAMS METHOD
import layoutParams_crop_method from './layoutParams_crop_method';
import layoutParams_crop_alignment from './layoutParams_crop_alignment';
import layoutParams_structure_groupsOrder from './layoutParams_structure_groupsOrder';
import layoutParams_structure_layoutOrientation from './layoutParams_structure_layoutOrientation';
import layoutParams_structure_responsiveMode from './layoutParams_structure_responsiveMode';
import layoutParams_structure_scrollDirection from './layoutParams_structure_scrollDirection';
import layoutParams_groups_allowedGroupTypes from './layoutParams_groups_allowedGroupTypes';
import layoutParams_thumbnails_alignment from './layoutParams_thumbnails_alignment';
import layoutParams_navigationArrows_verticalAlignment from './layoutParams_navigationArrows_verticalAlignment';
import layoutParams_navigationArrows_position from './layoutParams_navigationArrows_position';
import layoutParams_navigationArrows_type from './layoutParams_navigationArrows_type';
import layoutParams_navigationArrows_container_type from './layoutParams_navigationArrows_container_type';
import layoutParams_info_layout from './layoutParams_info_layout';
import layoutParams_info_sizeUnits from './layoutParams_info_sizeUnits';
import layoutParams_info_placement from './layoutParams_info_placement';
import layoutParams_targetItemSize_unit from './layoutParams_targetItemSize_unit';
import behaviourParams_item_clickAction from './behaviourParams_item_clickAction';
import behaviourParams_item_video_playTrigger from './behaviourParams_item_video_playTrigger';
import behaviourParams_item_overlay_hoveringBehaviour from './behaviourParams_item_overlay_hoveringBehaviour';
import behaviourParams_item_overlay_hoverAnimation from './behaviourParams_item_overlay_hoverAnimation';
import behaviourParams_item_overlay_position from './behaviourParams_item_overlay_position';
import behaviourParams_item_overlay_sizeUnits from './behaviourParams_item_overlay_sizeUnits';
import behaviourParams_item_content_hoverAnimation from './behaviourParams_item_content_hoverAnimation';
import behaviourParams_item_content_placementAnimation from './behaviourParams_item_content_placementAnimation';
import behaviourParams_item_content_loader from './behaviourParams_item_content_loader';
import behaviourParams_item_secondaryMedia_trigger from './behaviourParams_item_secondaryMedia_trigger';
import behaviourParams_item_secondaryMedia_behaviour from './behaviourParams_item_secondaryMedia_behaviour';
import behaviourParams_gallery_layoutDirection from './behaviourParams_gallery_layoutDirection';
import behaviourParams_gallery_scrollAnimation from './behaviourParams_gallery_scrollAnimation';
import behaviourParams_gallery_vertical_loadMore_amount from './behaviourParams_gallery_vertical_loadMore_amount';
import behaviourParams_gallery_horizontal_slideAnimation from './behaviourParams_gallery_horizontal_slideAnimation';
import behaviourParams_gallery_horizontal_slideTransition from './behaviourParams_gallery_horizontal_slideTransition';
import behaviourParams_gallery_horizontal_autoSlide_behaviour from './behaviourParams_gallery_horizontal_autoSlide_behaviour';
import behaviourParams_gallery_horizontal_slideshowInfo_buttonsAlignment from './behaviourParams_gallery_horizontal_slideshowInfo_buttonsAlignment';
import stylingParams_itemResolutionMode from './stylingParams_itemResolutionMode';
import layoutParams_thumbnails_position from './layoutParams_thumbnails_position';
// NEW STYPEPARAMS METHOD
export default {
    arrowsPosition: arrowsPosition,
    itemResolutionMode: itemResolutionMode,
    arrowsVerticalPosition: arrowsVerticalPosition,
    cubeType: cubeType,
    dimensions: dimensions,
    events: events,
    deviceType: deviceType,
    gallerySizeType: gallerySizeType,
    galleryTextAlign: galleryTextAlign,
    gridStyle: gridStyle,
    cubeFitPosition: cubeFitPosition,
    groupTypes: groupTypes,
    imageHoverAnimations: imageHoverAnimations,
    infoBehaviourOnHover: infoBehaviourOnHover,
    infoType: infoType,
    isVertical: isVertical,
    itemClick: itemClick,
    layout: layout,
    isLayout: isLayout,
    layoutDirection: layoutDirection,
    loadingMode: loadingMode,
    loadingWithColorMode: loadingWithColorMode,
    loadMoreAmount: loadMoreAmount,
    mobileSwipeAnimations: mobileSwipeAnimations,
    overlayAnimations: overlayAnimations,
    placements: placements,
    hasExternalAbovePlacement: hasExternalAbovePlacement,
    hasExternalBelowPlacement: hasExternalBelowPlacement,
    hasHoverPlacement: hasHoverPlacement,
    hasExternalRightPlacement: hasExternalRightPlacement,
    hasExternalLeftPlacement: hasExternalLeftPlacement,
    hasExternalVerticalPlacement: hasExternalVerticalPlacement,
    hasExternalHorizontalPlacement: hasExternalHorizontalPlacement,
    isExternalAbovePlacement: isExternalAbovePlacement,
    isExternalBelowPlacement: isExternalBelowPlacement,
    isHoverPlacement: isHoverPlacement,
    isExternalRightPlacement: isExternalRightPlacement,
    isExternalLeftPlacement: isExternalLeftPlacement,
    isExternalVerticalPlacement: isExternalVerticalPlacement,
    isExternalHorizontalPlacement: isExternalHorizontalPlacement,
    isConstantVerticalPlacement: isConstantVerticalPlacement,
    resizeMethods: resizeMethods,
    scrollAnimations: scrollAnimations,
    slideAnimations: slideAnimations,
    scrollDirection: scrollDirection,
    socialNetworks: socialNetworks,
    textBoxWidthCalculationOptions: textBoxWidthCalculationOptions,
    thumbnailsAlignment: thumbnailsAlignment,
    thumbnailsPosition: thumbnailsPosition,
    urlSizes: urlSizes,
    urlTypes: urlTypes,
    videoPlay: videoPlay,
    viewMode: viewMode,
    imagePlacementAnimations: imagePlacementAnimations,
    slideTransition: slideTransition,
    overlayPositions: overlayPositions,
    overlaySizeType: overlaySizeType,
    autoSlideshowTypes: autoSlideshowTypes,
    arrowsType: arrowsType,
    arrowsContainerStyleType: arrowsContainerStyleType,
    autoSlideBehaviour: autoSlideBehaviour,
    secondaryMediaTrigger: secondaryMediaTrigger,
    secondaryMediaBehaviour: secondaryMediaBehaviour,
    // NEW STYPEPARAMS METHOD
    layoutParams_crop_method: layoutParams_crop_method,
    layoutParams_crop_alignment: layoutParams_crop_alignment,
    layoutParams_structure_groupsOrder: layoutParams_structure_groupsOrder,
    layoutParams_structure_layoutOrientation: layoutParams_structure_layoutOrientation,
    layoutParams_structure_responsiveMode: layoutParams_structure_responsiveMode,
    layoutParams_structure_scrollDirection: layoutParams_structure_scrollDirection,
    layoutParams_groups_allowedGroupTypes: layoutParams_groups_allowedGroupTypes,
    layoutParams_thumbnails_alignment: layoutParams_thumbnails_alignment,
    layoutParams_navigationArrows_verticalAlignment: layoutParams_navigationArrows_verticalAlignment,
    layoutParams_navigationArrows_position: layoutParams_navigationArrows_position,
    layoutParams_navigationArrows_type: layoutParams_navigationArrows_type,
    layoutParams_navigationArrows_container_type: layoutParams_navigationArrows_container_type,
    layoutParams_info_layout: layoutParams_info_layout,
    layoutParams_info_sizeUnits: layoutParams_info_sizeUnits,
    layoutParams_info_placement: layoutParams_info_placement,
    layoutParams_targetItemSize_unit: layoutParams_targetItemSize_unit,
    behaviourParams_item_clickAction: behaviourParams_item_clickAction,
    behaviourParams_item_video_playTrigger: behaviourParams_item_video_playTrigger,
    behaviourParams_item_overlay_hoveringBehaviour: behaviourParams_item_overlay_hoveringBehaviour,
    behaviourParams_item_overlay_hoverAnimation: behaviourParams_item_overlay_hoverAnimation,
    behaviourParams_item_overlay_position: behaviourParams_item_overlay_position,
    behaviourParams_item_overlay_sizeUnits: behaviourParams_item_overlay_sizeUnits,
    behaviourParams_item_content_hoverAnimation: behaviourParams_item_content_hoverAnimation,
    behaviourParams_item_content_placementAnimation: behaviourParams_item_content_placementAnimation,
    behaviourParams_item_content_loader: behaviourParams_item_content_loader,
    behaviourParams_item_secondaryMedia_trigger: behaviourParams_item_secondaryMedia_trigger,
    behaviourParams_item_secondaryMedia_behaviour: behaviourParams_item_secondaryMedia_behaviour,
    behaviourParams_gallery_layoutDirection: behaviourParams_gallery_layoutDirection,
    behaviourParams_gallery_scrollAnimation: behaviourParams_gallery_scrollAnimation,
    behaviourParams_gallery_vertical_loadMore_amount: behaviourParams_gallery_vertical_loadMore_amount,
    behaviourParams_gallery_horizontal_slideAnimation: behaviourParams_gallery_horizontal_slideAnimation,
    behaviourParams_gallery_horizontal_slideTransition: behaviourParams_gallery_horizontal_slideTransition,
    behaviourParams_gallery_horizontal_autoSlide_behaviour: behaviourParams_gallery_horizontal_autoSlide_behaviour,
    behaviourParams_gallery_horizontal_slideshowInfo_buttonsAlignment: behaviourParams_gallery_horizontal_slideshowInfo_buttonsAlignment,
    stylingParams_itemResolutionMode: stylingParams_itemResolutionMode,
    layoutParams_thumbnails_position: layoutParams_thumbnails_position,
    // NEW STYPEPARAMS METHOD
};
//# sourceMappingURL=index.js.map